<template>
  <div class="PreviewWindows2018Chrome" :class="{ 's-hasImage': hasImage, 's-noIcon': !hasIcon, 's-onlyOneAction': onlyOneAction, 's-hover': isHover }" @mouseover="isHover = true" @mouseout="isHover = false">
      <div v-if="hasImage" class="Image" :style="{'backgroundImage': 'url(' + base.image + ')'}"></div>
      <div class="NonImageArea">
        <div class="Icon" :style="{'backgroundImage': hasIcon && 'url(' + base.icon + ')'}"></div>
        <div class="Details">
            <div class="Title" ref="title" v-html="base.title"></div>
            <div class="Body" ref="body" v-html="base.body"></div>
            <div class="Info" v-html="info"></div>
        </div>
      </div>
      <div v-if="hasMenu" class="Menu">
        <div v-html="base.action1Text"></div>
        <div v-if="base.action2Text" v-html="base.action2Text"></div>
      </div>
      <div class="Arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'PreviewWindows2018Chrome',
  props: {
    base: Object
  },
  data() {
    return {
      isHover: false
    }
  },
  computed: {
    hasMenu() {
      return !!this.base.action1Text
    },
    hasIcon() {
      return !!this.base.icon
    },
    hasImage() {
      return !!this.base.image
    },
    info() {
      return `Google Chrome &middot; ${this.base.domain}`
    },
    onlyOneAction() {
      return !!this.base.action1Text && !this.base.action2Text
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
  .clearfix::after {
      content: "";
      clear: both;
      display: table;
  }
  .PreviewWindows2018Chrome {
    width: 366px; // 2x for border
    min-height: 120px;
    user-select: none;
    position: relative;
    border: 1px solid #dedede;
    font-family: 'Open Sans', sans-serif;
    box-shadow: 0px 0px 5px rgb(222, 222, 222);
    background-color: #2e79a6;
    color: #fff;
    padding-bottom: 16px;
    font-size: 13.3px;
  }
  .Image {
    background-color: transparent;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top left;
    width: 364px;
    height: 180px;
  }
  .NonImageArea {
    position: relative;
    top: 24px;
    left: 16px;
  }
  .Icon {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 0px;
    left: 0px;
    background-size: cover;
    background-position: top left;
    background-repeat: no-repeat;
  }
  .s-noIcon .Icon {
    background-image: url('../assets/icon-windows2018-chrome-small.png');
    background-size: auto;
  }
  .Arrow {
    position: absolute;
    top: 12px;
    right: 13px;
    width: 12px;
    height: 11px;
    background-image: url('../assets/windows-arrow0.png');
  }
  .s-hover .Arrow {
    background-image: url('../assets/windows-arrow1.png');
  }
  .Details {
    position: relative;
    left: 65px;
    top: -2px;
    width: 250px;
    letter-spacing: .5px;
    .Title {
      font-weight: bold;
      max-height: 35px;
      overflow: hidden;
      margin-bottom: 5px;
      line-height: 1.5;
    }
    .Body {
      font-weight: 100;
      max-height: 75px;
      overflow: hidden;
      margin-bottom: 6px;
      line-height: 150%;
      color: #ddd;
    }
    .Info {
      font-size: 11px;
      margin-bottom: 27px;
      color: #ddd;
    }
  }
  .s-noIcon .Details {
    left: 32px;
  }
  .Menu {
    position: relative;
    margin-left: 16px;
    margin-right: 16px;
    padding-top: 16px;
    font-weight: bold;
    & > div {
      height: 33px;
      width: 164px;
      background: rgba(255, 255, 255, 0.2);
      display: inline-block;
      text-align: center;
      padding-top: 8px;
      cursor: pointer;
    }
    & > div:hover {
      background: rgba(255, 255, 255, 0.3);
    }
    & > div:first-of-type {
      margin-right: 4px;
    }
  }
  .s-onlyOneAction .Menu > div {
    position: relative;
    left: 164px;
  }
</style>
